export default "__VITE_ASSET__e5c80edf__"